import { Injectable } from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromActions from "./service-requested-change.actions";
import {map, switchMap} from "rxjs/operators";
import * as fromGraphql from "./service-requested-change.graphql";
import {Apollo} from "apollo-angular";
import {Store} from "@ngrx/store";
import {AppState} from "../../../reducers";
import {NotificationService} from "../../../../services/notification.service";
import {ResponseCodeService} from "../../../../services/response-code.service";
import {getServiceRequestedChanges} from "./service-requested-change.actions";



@Injectable()
export class ServiceRequestedChangeEffects {

  getServiceRequestedChanges$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getServiceRequestedChanges),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_REQUESTED_CHANGE_SERVICES,
        fetchPolicy: 'network-only',
        variables: {
          institutionUniqueId: action.institutionUniqueId
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching services'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadServiceRequestedChanges({ serviceRequestedChanges: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
